import "@/icons"; // icon
import "@/styles/scrollbar.scss";
import "utils/eventBus";
import Vue from "vue";
import VuetifyToast from "vuetify-toast-snackbar";
import App from "./App.vue";
import * as filters from "./filters"; // global filters
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import "./styles/index.scss";
import Plugins from "./components/Plugins";

import mobile from "./styles/mobile.scss";

import Vant from 'vant'
import 'vant/lib/index.css'

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import "./assets/kubuqi_icon/iconfont.css";

// 引入vue无缝滚动
import scroll from "vue-seamless-scroll";
Vue.use(scroll);

Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(Plugins);
// 时间格式化
import moment from "moment";
//挂载到原型
Vue.prototype.$moment = moment;
//汉化，否则显示日期格式是国外的日期格式
moment.locale("zh-CN");

//文件中调用
// this.$moment()

// 多语言切换
import vueI18n from "vue-i18n";
Vue.use(vueI18n);
const locale = localStorage.getItem("lang");
const i18n = new vueI18n({
  locale: locale || "zhComplex",
  messages: {
    // 中文简体
    zhSimple: require("@/assets/lang/zhSimple"),
    // 中文繁体
    zhComplex: require("@/assets/lang/zhComplex"),
    // 英语
    en: require("@/assets/lang/en"),
  },
});

Vue.use(VuetifyToast, {
  x: "center",
  y: "top",
  icon: "mdi-alert-circle",
  dismissable: false,
  showClose: true,
  closeIcon: "mdi-close",
  closeColor: "#fff",
});

// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// import VConsole from 'vconsole';
// let vConsole = new VConsole();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
